import React from "react";
import { ThreeCircles } from "react-loader-spinner";

const Loading = ({ text }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ThreeCircles
          visible={true}
          height="70"
          width="70"
          color="#000000"
          ariaLabel="three-circles-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
        <p
          style={{
            fontSize: "15px",
            fontWeight: "bold",
            color: "#000000",
          }}
        >
          {text}
        </p>
      </div>
    </div>
  );
};

export default Loading;
